import { useSelector } from 'react-redux';

import { messages } from './messages';
import Global from '../../../store/global-selectors';
import { OrdersGridColumns } from '../../../store/orders/grid/orders-grid-columns';
import type { Tote } from '../../../pages/settings/inventory-warehouses/types';

type ToteColumnProps = {
  fulfillmentPlanId: string;
};

const ToteColumnComponent = ({ fulfillmentPlanId }: ToteColumnProps) => {
  const toteId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'toteId',
    }),
  );

  const totes: Tote[] = useSelector(Global.selectSellerTotes);

  if (!toteId || !totes?.length) return null;

  const tote = totes.find((t) => t.toteId === toteId);

  if (!tote) return null;

  return <div>{tote.toteName}</div>;
};

type RenderOptions = {
  isExpanded?: boolean;
  isFirstRow?: boolean;
};

type ColumnData = {
  id: string;
};

export const ToteColumn = {
  getMessageDescriptor: () => messages.tote,
  id: OrdersGridColumns.Tote,
  render: (data: ColumnData, { isExpanded = false, isFirstRow = true }: RenderOptions = {}) => {
    if (isExpanded && !isFirstRow) {
      return null;
    }
    return <ToteColumnComponent fulfillmentPlanId={data.id} />;
  },
};
